const DEFAULT_API_BASE = 'https://api.revisdom.com';

/** localhost'ta CRA setupProxy / serve-with-proxy üzerinden same-origin /api kullan */
export function getApiBasePath(): string {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return '';
    }
  }

  const envUrl = process.env.REACT_APP_API_BASE_URL?.trim();
  if (envUrl) {
    return envUrl.replace(/\/+$/, '');
  }

  return DEFAULT_API_BASE;
}

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBasePath()}${normalizedPath}`;
}
